import { render, staticRenderFns } from "./Education1.vue?vue&type=template&id=11c96912&"
import script from "./Education1.vue?vue&type=script&lang=js&"
export * from "./Education1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports